/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // OVERLAP MODE MOBILE //

  class ProductOverlap {
    constructor(container) {
      this.container = container;
      this.productImages = container.querySelector('.product__images--mobile-overlap');
      this.productContent = container.querySelector('.product__content');
      this.slider = this.productImages?.querySelector('[data-product-media-list]');
      this.slides = this.productImages?.querySelectorAll('.product__slide');
      
      if (!this.productImages || !this.slider || !this.slides || this.slides.length === 0) {
        console.log('Overlap mode not active or no slides found');
        return;
      }

      this.currentSlide = 0;
      this.init();
    }

    init() {
      if (window.innerWidth > 767) {
        console.log('Desktop view, skipping overlap mode');
        return;
      }

      console.log('Initializing overlap mode with', this.slides.length, 'slides');
      this.createProgressBar();
      this.attachScrollListener();
      this.updateProgressBar();
    }

    createProgressBar() {
      const existing = this.productImages.querySelector('.overlap-progress-bar');
      if (existing) existing.remove();

      const progressBar = document.createElement('div');
      progressBar.className = 'overlap-progress-bar';
      
      const track = document.createElement('div');
      track.className = 'overlap-progress-track';
      progressBar.appendChild(track);

      this.productImages.appendChild(progressBar);
      this.progressBar = progressBar;
      this.updateProgressBar();

      console.log('✓ Progress bar created with', this.slides.length, 'slides');
    }

    attachScrollListener() {
      if (!this.slider) return;

      this.slider.addEventListener('scroll', () => {
        this.updateProgressBar();
      }, { passive: true });

      console.log('✓ Scroll listener attached');
    }

    updateProgressBar() {
      if (!this.slider || !this.progressBar) return;

      const scrollLeft = this.slider.scrollLeft;
      const slideWidth = this.slides[0]?.offsetWidth || window.innerWidth;
      const currentIndex = Math.round(scrollLeft / slideWidth);

      const itemWidth = 100 / this.slides.length;
      const translateX = currentIndex * 100;

      let knob = this.progressBar.querySelector('.overlap-progress-knob');
      if (!knob) {
        knob = document.createElement('div');
        knob.className = 'overlap-progress-knob';
        this.progressBar.appendChild(knob);
      }

      knob.style.transform = `translateX(${translateX}%)`;
      knob.style.width = `${itemWidth}%`;
    }

    destroy() {
      if (this.progressBar) {
        this.progressBar.remove();
        console.log('Progress bar destroyed');
      }
    }
  }

  // Initialisierung
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOverlapMode);
  } else {
    initOverlapMode();
  }

  function initOverlapMode() {
    console.log('DOM ready, initializing overlap mode...');
    
    const productComponent = document.querySelector('product-component');
    if (productComponent) {
      const overlapMode = new ProductOverlap(productComponent);
      
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          const isMobile = window.innerWidth <= 767;
          if (isMobile && !overlapMode.progressBar) {
            overlapMode.init();
          } else if (!isMobile && overlapMode.progressBar) {
            overlapMode.destroy();
          }
        }, 250);
      });
    } else {
      console.log('product-component not found');
    }
  }

// === BRIGHTNESS WITH HEADER COLOR - CLEAN VERSION ===
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const slider = document.querySelector('.product__images--mobile-overlap [data-product-media-list]');
    const slides = document.querySelectorAll('.product__images--mobile-overlap .product__slide');
    const header = document.querySelector('.header__wrapper');
    
    if (!slider || !slides.length || !header) return;

    function updateHeaderColor() {
      const scrollLeft = slider.scrollLeft;
      const slideWidth = slides[0].offsetWidth || window.innerWidth;
      const currentIndex = Math.round(scrollLeft / slideWidth);
      const currentSlide = slides[currentIndex];
      const img = currentSlide?.querySelector('img');

      if (!img || !img.complete) return;

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = 100;
      canvas.height = 100;

      try {
        ctx.drawImage(img, 0, 0, 100, 100);
        const imageData = ctx.getImageData(0, 0, 100, 30);
        const data = imageData.data;
        
        let totalBrightness = 0;
        let opaquePixels = 0;

        for (let i = 0; i < data.length; i += 4) {
          const alpha = data[i + 3];
          
          if (alpha > 50) {
            const brightness = (0.299 * data[i] + 0.587 * data[i+1] + 0.114 * data[i+2]);
            totalBrightness += brightness;
            opaquePixels++;
          }
        }

        if (opaquePixels < 100) {
          header.classList.add('header--light-bg');
          header.classList.remove('header--dark-bg');
          return;
        }

        const avgBrightness = totalBrightness / opaquePixels;
        
        if (avgBrightness < 200) {
          header.classList.add('header--dark-bg');
          header.classList.remove('header--light-bg');
        } else {
          header.classList.add('header--light-bg');
          header.classList.remove('header--dark-bg');
        }
        
      } catch (e) {}
    }

    updateHeaderColor();
    slider.addEventListener('scroll', updateHeaderColor, { passive: true });
  }, 500);
});


/* ========================================
   Collection Subcategory Navigation Slider
   ======================================== */

 let attempts = 0;
  const maxAttempts = 20;
  
  function findAndSetNav() {
    attempts++;
    const nav = document.querySelector('[data-sticky-nav]') 
                || document.querySelector('.subcategory-nav-wrapper')
                || document.querySelector('.subcategory-nav');
    
    if (nav) {
      const height = nav.offsetHeight;
      document.documentElement.style.setProperty('--subcategory-nav-height', height + 'px');
      console.log('✅ Nav gefunden nach', attempts, 'Versuchen. Höhe:', height + 'px');
      return true;
    }
    
    if (attempts < maxAttempts) {
      console.log('🔄 Versuch', attempts, '- warte...');
      setTimeout(findAndSetNav, 100);
    } else {
      console.log('🔴 Nav nach', attempts, 'Versuchen nicht gefunden');
    }
    
    return false;
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', findAndSetNav);
  } else {
    findAndSetNav();
  }

  /* ========================================
   Mega Menü
   ======================================== */

})();